import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  titleRow: {
    ...dFlex('space-between'),

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      ...dFlex('space-between', 'start'),
      flexDirection: 'column',
      gap: '8px',
    },
  },
  row: {
    ...dFlex('space-between'),
  },
  rowGap: {
    ...dFlex(),
    gap: '8px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: '8px',
    marginTop: '16px',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: '1fr',
      rowGap: '8px',
    },
  },
  column: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '8px',
  },
  columnText: {
    ...dFlex(),
    flexDirection: 'column',
    gap: '8px',
  },
  stats: {
    ...dFlex('space-between'),
    flexDirection: 'row',
  },
  statsValue: {
    width: 'unset',
  },
  block: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '8px',
    background: theme.background.b2,
    borderRadius: theme.borderRadius.md,
    padding: '8px',
  },
  text: {
    textAlign: 'right',
  },
  title: {
    margin: '16px 0',
  },
  margin: {
    marginTop: '16px',
  },
}));

export default useStyles;
